module.exports = __webpack_public_path__ + "img/IMG_1444_L_BlackMatted_MockedUp.5bb54e97.jpg";